import React from 'react';
import { Box, Typography } from '@mui/material';

function Page2SubPageC4() {
  return (
    <Box p={4}>
      <Typography variant="h4">Local</Typography>
    </Box>
  );
}

export default Page2SubPageC4;
